// IconNavbar — shared chrome for floating canvas navbars.
//
// Wraps `Navbar` with the standard "floating island" treatment used across
// the editor: common-card theme, C1 round, V Z padding, A gap, no text
// selection. Consumers (AppNavbar, Zoombar, CvModesBar, WorkspaceViews,
// AppHeader, etc.) extend this and only override position/content.
//
// Why a thin wrapper over Navbar:
//   - Navbar in @symbo-ls/brand carries layout primitives (flex row,
//     sticky-on-default, etc.). IconNavbar pins the theme + spacing + round
//     so every floating bar reads as one component family.
//   - One place to retune the look (theme, padding, round) for all bars.
//
// Position overrides — IconNavbar deliberately does NOT pin `position` so
// callers can choose `sticky`, `absolute`, or default. Same for top/left/
// right/bottom: callers anchor wherever they need.

export const IconNavbar = {
  extends: 'Navbar',
  // `navbar` theme from @symbo-ls/brand (theme.js:371) supplies both color
  // and an opaque blurred background — same palette every floating bar
  // (AppHeader, AppNavbar, Zoombar, CvModesBar) shares. NO `background`
  // override here so the theme's bg actually shows; consumers that want a
  // transparent chrome can set `background: 'transparent'` themselves.
  theme: 'navbar',
  flow: 'x',
  align: 'center',
  gap: 'A',
  padding: 'V Z',
  round: 'radiusPill',
  userSelect: 'none'
}
